import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue, useContentObjectType } from 'content-management-data-lib';
import { useContentActions } from '../providers/ContentActionsProvider';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getErrorTypeKey = (actionId, {
  bulkActionState: {
    errorSubCategory,
    errorTokens
  }
}) => {
  let key = errorSubCategory;
  if (errorSubCategory === 'MISSING_NECESSARY_PUBLISH_VALUE' && errorTokens) {
    // construct key for missing field values like author, featured image, non-temp slug urls
    key = `${errorSubCategory}_${errorTokens.missingValue[0].toUpperCase().replace(/[-\s]+/g, '_')}`;
  }
  if (isValidI18nKey(`content-management-actions-lib.modals.bulkUpdateErrorsList.${actionId}.errorTypes.sectionTitles.${key}`)) {
    return key;
  }

  // TODO: Log sentry
  // Raven.captureMessage('Translation Missing For Bulk Error Type', {
  //   extra: { missingKey: key },
  // });

  return 'UNKNOWN';
};
const ErrorSections = () => {
  const {
    bulkUpdateErrorsData: {
      results,
      actionId
    }
  } = useContentActions();
  const {
    contentObjectTypePluralNoun,
    contentObjectTypeSingularNoun
  } = useContentObjectType();
  const failedResultsData = results.reduce((acc, errorState) => {
    const errorTypeKey = getErrorTypeKey(actionId, errorState);
    if (errorTypeKey) {
      if (errorTypeKey in acc) {
        acc[errorTypeKey].push(errorState);
      } else {
        acc[errorTypeKey] = [errorState];
      }
    }
    return acc;
  }, {});
  const errorTypes = Object.keys(failedResultsData);
  const defaultOpen = results.length <= 2 || errorTypes.length === 1;
  const {
    allActions
  } = useContentActions();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: errorTypes.map(errorType => /*#__PURE__*/_jsx(ExpandableSection, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `content-management-actions-lib.modals.bulkUpdateErrorsList.${actionId}.errorTypes.sectionTitles.${errorType}`,
        options: {
          contentObjectTypePluralNoun,
          contentObjectTypeSingularNoun
        }
      }),
      indentation: "compact",
      defaultOpen: defaultOpen,
      children: /*#__PURE__*/_jsx(List, {
        styled: true,
        marginBlockEnd: "400",
        children: failedResultsData[errorType].reduce((acc, {
          crmObject
        }) => {
          const objectId = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.ID);
          acc.push( /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Link, {
              external: true,
              onClick: () => {
                if (allActions.edit && allActions.edit.onActionButtonClick) {
                  allActions.edit.onActionButtonClick(crmObject, {
                    shouldOpenInNewTab: true
                  });
                }
              },
              children: getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.NAME)
            }, objectId)
          }));
          return acc;
        }, [])
      })
    }, errorType))
  });
};
const BulkUpdateErrorsListModal = () => {
  const {
    setIsBulkUpdateErrorsModalOpen,
    bulkUpdateErrorsData: {
      results,
      actionId
    }
  } = useContentActions();
  const {
    contentObjectTypePluralNoun,
    contentObjectTypeSingularNoun
  } = useContentObjectType();
  const closeModal = () => {
    setIsBulkUpdateErrorsModalOpen(false);
  };
  const count = results.length;
  return /*#__PURE__*/_jsxs(Modal, {
    width: 550,
    "data-test-id": "bulk-update-errors-list-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeModal
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `content-management-actions-lib.modals.bulkUpdateErrorsList.${actionId}.header`,
          options: {
            count,
            contentObjectTypePluralNoun,
            contentObjectTypeSingularNoun
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `content-management-actions-lib.modals.bulkUpdateErrorsList.${actionId}.message`,
        options: {
          count,
          contentObjectTypePluralNoun,
          contentObjectTypeSingularNoun
        }
      }), /*#__PURE__*/_jsx(ScrollContainer, {
        maxHeight: 300,
        marginBlockStart: "500",
        children: /*#__PURE__*/_jsx(ErrorSections, {})
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "modal-confirm",
        onClick: closeModal,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `content-management-actions-lib.modals.bulkUpdateErrorsList.${actionId}.buttons.okay`
        })
      })
    })]
  });
};
export default BulkUpdateErrorsListModal;